module.exports = __webpack_public_path__ + "img/cov-partner.6a0fb939.jpg";